import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import moment from 'moment'
import ViewDetails from '../viewConstituents'

let chartData = null
class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isDetailsShown: false,
			selectedFilter: null
		}
		
		this.handleChart = this.handleChart.bind(this)
	}

	handleChart (data) {
		var that = this
		// window.c3.generate({
		// 	bindto: '#crimes-chart',
		// 	data: {
		// 		columns: data.data,
		// 		type: 'pie'
		// 	},
		// 	color: {
		// 		pattern: data.legends
		// 	}
		// })
		const mData = data.data.map((i) => i[1])
		const mLegends = data.data.map((i) => i[0])
		const options = {
			chart: {
				height: 300,
				type: 'bar',
				toolbar: {
					show: 1
				},
				events: {
					click: function(event, chartContext, config) {
						// console.log(config)
						const dataIndex = (config.dataPointIndex == -1) ? 0 : config.dataPointIndex
						const mData = data.data[dataIndex][0]
						that.setState({ isDetailsShown: true, selectedFilter: mData })
					}
				}
			},
			plotOptions: {
				bar: {
					columnWidth: '14%',
					endingShape: 'rounded'
				}
			},
			dataLabels: {
				enabled: 1
			},
			series: [{
				name: 'Experienced Crimes',
				data: mData
			}],
			grid: {
				yaxis: {
					lines: {
						show: !1
					}
				}
			},
			xaxis: {
				labels: {
					rotate: -45
				},
				categories: mLegends
			},
			colors: data.legends,
			fill: {
				type: 'gradient',
				gradient: {
					shade: 'dark',
					type: 'vertical',
					shadeIntensity: 1,
					gradientToColors: data.legends,
					inverseColors: !0,
					opacityFrom: .85,
					opacityTo: .85,
					stops: [0, 100, 100, 100]
				}
			}
		}
		chartData = new window.ApexCharts(document.querySelector('#crimes-chart'), options).render()
		if (!chartData) {
			chartData.render()
		}
	}

	render() {
		const { isDetailsShown, selectedFilter } = this.state
		const { dashboardData } = this.props
		const dataChart = _.has(dashboardData, 'crimeTypeChart') ? dashboardData.crimeTypeChart : {}
		var that = this
		setTimeout(() => {
			that.handleChart(dataChart)
		}, 1000)

		return (
			<React.Fragment>
				<div className="col-xl-12">
					<div className="card">
						<div className="card-body">
							<h4 className="header-title mb-3">Experienced/Victim of Crimes</h4>

							<div dir="ltr">
								<div id="crimes-chart"></div>
							</div>
						</div>
					</div>
				</div>
				{
					isDetailsShown &&
					<ViewDetails 
						filterValue={selectedFilter}
						visible={isDetailsShown}
						onCancel={() => this.setState({ isDetailsShown: false, selectedFilter: null })}
					/>
				}
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
